import React, {useEffect} from "react";

import {useTypedSelector} from "src/hooks/useTypedSelector";
import { DictionarySecurityObject } from "src/types/security";
import {userStorage} from "src/utils/localStorage";
import { HttpCacheSecurityObject } from "src/http/cache/httpCacheSecurityObject";
import { useAction } from "src/hooks/useAction";

interface SecurityManagerProps {
    setDictionarySecurityObject: (dictionary: DictionarySecurityObject | undefined) => void
}

function SecurityManager(props: SecurityManagerProps) {
    const { reloadProfile } = useAction();
    const user : number | undefined = userStorage.getUserId();
    const { relaod } = useTypedSelector((state) => state.profile);
    
    const clearSecurityObjects = () => Promise.resolve(undefined);
    
    const loadSecurityObjects = (cancelReload: boolean) => {
        const promise : () => Promise<DictionarySecurityObject | undefined> = user ?
            HttpCacheSecurityObject.getByUser :
            clearSecurityObjects;
        
        promise()
            .then(props.setDictionarySecurityObject)
            .finally(() => {
                if (cancelReload)
                    reloadProfile(false);
            });
    }
    
    useEffect(() => {
        loadSecurityObjects(false);
    }, [user]);

    useEffect(() => {
        if (relaod)
            loadSecurityObjects(true);
    }, [relaod]);
    
    return (
        <></>
    );
}

export default SecurityManager;